export default "__VITE_ASSET__DfxxLWXe__"